import { jsx as _jsx } from "react/jsx-runtime";
import { CardFull } from "@aviv-classified-card/card/full";
import { useTrackingCardClick } from "@/hooks";
import { Box } from "@gemini/core";
import { FavoriteHeart } from "@seeker-consumer-portal/favorite-heart";
export const SimilarCard = ({ item, width }) => {
    var _a, _b, _c, _d;
    const handleTrackingCardClick = useTrackingCardClick(item.id);
    const favoriteTracking = {
        id: (_a = item === null || item === void 0 ? void 0 : item.id) !== null && _a !== void 0 ? _a : "",
        distribution_type: (_c = (_b = item === null || item === void 0 ? void 0 : item.tracking) === null || _b === void 0 ? void 0 : _b.distribution_type) !== null && _c !== void 0 ? _c : "",
        estate_type: (_d = item === null || item === void 0 ? void 0 : item.tracking) === null || _d === void 0 ? void 0 : _d.estate_type,
        list_name: "classified_detail",
    };
    return (_jsx(Box, { width: width, maxWidth: "100%", onClick: handleTrackingCardClick, children: _jsx(CardFull, { id: item.id, actionSlot: _jsx(FavoriteHeart, { classifiedId: item.id, tracking: favoriteTracking }) }, item.id) }));
};
